import { ProfileRoutingModule } from './profile.routing.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedAppModule } from '../app.module.shared';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// SALES COMPONENTS
import { ProfileSettingsComponent } from './profile.settings/profile.settings.component';


@NgModule({
    declarations: [
        ProfileSettingsComponent
    ],
    imports: [
        CommonModule,
        SharedAppModule,
        ReactiveFormsModule,
        FormsModule,

        ProfileRoutingModule

    ],
    entryComponents: [

    ]
})

export class ProfileModule { }
